import styled from "styled-components";

export const Circle = styled.div`
  width: ${p => p.small ? '8px' : '16px'};
  height: ${p => p.small ? '8px' : '16px'};
  border-radius: 50%;
  background: #FFFFFF;
`;